import React from "react";
import { Crown, Clock, Radio, Check } from "lucide-react";
import { cn } from "@/lib/utils";

const MAP = {
  free: { label: "Free", className: "bg-emerald-100 text-emerald-700", Icon: Check },
  premium: {
    label: "Premium",
    className: "bg-gradient-to-r from-amber-400 to-amber-600 text-white shadow-sm",
    Icon: Crown,
  },
  sold_out: { label: "Sold Out", className: "bg-slate-200 text-slate-600", Icon: null },
  live: { label: "Live Now", className: "bg-live text-white", Icon: "pulse" },
  starting_soon: {
    label: "Starting Soon",
    className: "bg-brand/10 text-brand",
    Icon: Clock,
  },
};

export function EventStatusBadge({ status, className, size = "md" }) {
  const cfg = MAP[status] || MAP.free;
  const pad = size === "sm" ? "px-2.5 py-1 text-[10px]" : "px-3 py-1 text-xs";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-bold uppercase tracking-wide",
        pad,
        cfg.className,
        className
      )}
    >
      {cfg.Icon === "pulse" ? (
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/80 opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
        </span>
      ) : cfg.Icon ? (
        <cfg.Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />
      ) : null}
      {cfg.label}
    </span>
  );
}

export default EventStatusBadge;
